import { connect } from 'react-redux';
import PageHelmet from 'components/PageHelmet/PageHelmet';
import { getCompanyName } from 'store/modules/company';
import { getFacilityById } from 'store/modules/facilities';
import { getSupport, getSocialMedia } from 'store/modules/site';
import { getPageAlternativeLocales } from 'store/modules/page';

const mapStateToProps = (state, ownProps) => ({
  facility: getFacilityById(state, ownProps.facilityId),
  companyName: getCompanyName(state),
  support: getSupport(state),
  socialMedia: getSocialMedia(state),
  alternativeLocales: getPageAlternativeLocales(state),
});

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageHelmet);
